import { useSelector } from 'react-redux';
import { State } from '../types/store';
import { getCalculationClass, MarginCalculation } from '../utils/marginCalculation';

export default function useMarginCalculation(): MarginCalculation {
  const company = useSelector((state: State) => state.userCompanies.select.selectedCompany);

  return getCalculationClass(company);
}
